import {selector} from "./selector";

function showFormErrors(errors) {
    for (let prop in errors) {
        if (prop === 'order_number') $(selector.errorMessage).html(errors[prop]); else $('#' + prop).addClass('is-invalid').next().html(errors[prop]).show();
    }
}

const submitForm = (e) => {
    e.preventDefault();

    const $form = $(e.target);

    let formData = $form.serialize();

    $(selector.invalidFeedback).hide();
    $(selector.isInvalid).removeClass('is-invalid');
    $(selector.preloader).show();

    setTimeout(function () {
        $.ajax({
            async: true,
            url: '/tag-porucivanje-process-form',
            method: 'POST',
            dataType: 'json',
            data: formData,
            success: function (response) {
                if (response) {
                    $(selector.tagSerialNumber).prop('disabled', true);
                    $(selector.tagVerificationCode).prop('disabled', true);
                    $(selector.phoneNumber).prop('disabled', true);
                    $(selector.captcha).prop('disabled', true);
                    $(selector.signature).val(response.signature);

                    $(document).off('submit', selector.checkoutForm);
                    $form.submit();
                } else {
                    $(selector.preloader).hide();
                    $(selector.errorMessage).show();
                    showFormErrors(response.errors);
                }
            },
            error: function (response) {
                $(selector.preloader).hide();
                $(selector.errorMessage).show();
                const r = $.parseJSON(response.responseText);
                showFormErrors(r.errors);
            }
        });
    }, 750);
}

const reloadCaptcha = (e) => {
    e.preventDefault();

    $.ajax({
        type: 'GET', url: '/reload-captcha', success: function (data) {
            $(selector.captchaHolder).html(data.captcha);
        }
    });
}

const verififyRegistrationPlate = (e) => {
    e.preventDefault();

    let registrationPlate = e.target.value;
    $.ajax({
        type: 'POST',
        data: {'registration_plate': registrationPlate},
        url: '/verify-registration-plate',
        success: function (response) {
            if (response.status === 'ok') {
                $(selector.serialNumber).val(response.serialNumber);
            }
        }
    });
}

const toggleCustomerType = function (e) {
    let customerType = parseInt($(e.target).val());

    if (customerType === 1) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').show();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').hide(); 
        for (const key in selector.form.businessForeign) $(selector.form.businessForeign[key]).parent('.form-group').hide();
    } else if (customerType === 2) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').hide();
        for (const key in selector.form.businessForeign) $(selector.form.businessForeign[key]).parent('.form-group').hide();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').show();
    } else if (customerType === 3) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').hide();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').hide();
        for (const key in selector.form.businessForeign) $(selector.form.businessForeign[key]).parent('.form-group').show();
    } else {
        console.error('Undefined customer type');
    }

    // Domace pravno lice je uvek Srbija (SEF), ostali biraju drzavu
    $(selector.form.country).parent('.form-group').toggle(customerType !== 2);
}

const initTutorialModal = function () {
    var $modal = $(selector.tutorialModal);
    var $iframe = $(selector.tutorialIframe);
    var originalSrc = $iframe.attr('src');

    $modal.on('hidden.bs.modal', function () {
        $iframe.attr('src', '');
        setTimeout(function () {
            $iframe.attr('src', originalSrc);
        }, 100);
    });
}

export {submitForm, reloadCaptcha, verififyRegistrationPlate, toggleCustomerType, initTutorialModal};